import { Injectable } from "@angular/core";
import { InputSearchChanged } from "@nms-angular-toolkit/nms-input-search";
import { FilterColumnParameters, PagingFilterType, RequestFilter } from "@nms-angular-toolkit/nms-table";
import { FILTER_TYPE_BY_SYMBOL } from "./table-filter-constants";

/**
 * Classe utilizada para funcionalidades relacionadas aos filtros da tabela.
 */
@Injectable({
    providedIn: "root"
})
export class TableFilterService {

    processFilterChanges(filterParameters: FilterColumnParameters) {
        let requestFilters: RequestFilter = {};
        if (filterParameters.inputSearchs.length > 0) {
            requestFilters = filterParameters.inputSearchs.reduce((accumulator, current) => {
                return this.convertInputSearchToFilter(accumulator, current);
            }, {} as RequestFilter);
        }

        return requestFilters;
    }

    /**
     * Converte os dados recebidos nos filtros da tabela
     */
    private convertInputSearchToFilter(filters: RequestFilter, current: InputSearchChanged) {
        const { filterTypeSymbol, value } = this.splitInFilterTypeSymbolAndValue(current.fieldValue);
        const valuesArray = value.split(",").map(value => value.trim());
        filters[current.fieldName] = {
            pagingFilterType: this.getPagingFilterType(filterTypeSymbol, current.fieldValue),
            filterValues: valuesArray
        };

        return filters;
    }

    /**
     * Separa o valor a ser filtrado e o símbolo que representa o tipo de comparação.
     *
     * Quando o valor não possui nenhum dos símbolos(>,<,=,!,%,*), exemplo "1/1/1", será
     * retornado um objeto padrão, com o valor do filtro, no seguinte formato {"''", "1/1/1"},
     * que representa o uso do 'CONTAINS'.
     *
     * @param fieldValue Valor inserido do campo de busca da coluna. Ex.: !10; %/12; >9; =DM1234
     * @returns Símbolo para comparação e valor a ser buscado. Ex.: {"=", "DM1234"}
     */
    private splitInFilterTypeSymbolAndValue(fieldValue: string) {
        const defaultFilterTypeRegExp = new RegExp(/^([>,<,=,!,%,||,\*]{1,2})(.*\S)$/, "g");
        const endsWithFilterTypeRegExp = new RegExp(/^(.*\S)(.*%)$/, "g");
        let { filterTypeSymbol, value } = { filterTypeSymbol: "''", value: fieldValue };

        if (fieldValue.match(defaultFilterTypeRegExp)) {
            ([filterTypeSymbol, value] = this.splitByRegex(defaultFilterTypeRegExp, fieldValue));
        } else if (fieldValue.match(endsWithFilterTypeRegExp)) {
            ([value, filterTypeSymbol] = this.splitByRegex(endsWithFilterTypeRegExp, fieldValue));
        }

        return { filterTypeSymbol, value };
    }

    private splitByRegex(regExp: RegExp, value: string) {
        return value.split(regExp).filter((entry) => entry !== "");
    }

    private getPagingFilterType(symbol: string, fieldValue: string) {
        if (FILTER_TYPE_BY_SYMBOL[symbol]) {
            return FILTER_TYPE_BY_SYMBOL[symbol](fieldValue)
        }

        return PagingFilterType.CONTAINS;
    }
}